// extracted by mini-css-extract-plugin
export default {"wrapper":"dashboardInfo_wrapper__twjxR","info":"dashboardInfo_info__tXBn1"};